export const enum ChartType {
    Candlestick = 0, 
    Line = 1, 
    Bar = 2,
    Area = 3, 
    HLC = 4,
    OHLC = 5
}
